"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManipulatorParamsCharacterPropertiesBased = exports.ManipulatorParamsPositionBased = exports.ManipulatorParamsBase = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var math_1 = require("@devexpress/utils/lib/utils/math");
var log_1 = require("../../../rich-utils/debug/logger/base-logger/log");
var ManipulatorParamsBase = (function () {
    function ManipulatorParamsBase(needCorrectParams, needCheckParams) {
        this.needCorrectParams = needCorrectParams;
        this.needCheckParams = needCheckParams;
    }
    ManipulatorParamsBase.prototype.fail = function (exceptionString) {
        if (log_1.Log.isDebug)
            throw new Error(exceptionString);
        return false;
    };
    ManipulatorParamsBase.prototype.correctAndCheckParams = function () {
        if (this.needCorrectParams)
            this.correctParams();
        if (this.needCheckParams)
            if (!this.checkParams())
                return false;
        return true;
    };
    ManipulatorParamsBase.prototype.innerCheck = function (paramOk, exceptionString) {
        if (!paramOk)
            this.fail(exceptionString);
        return paramOk;
    };
    return ManipulatorParamsBase;
}());
exports.ManipulatorParamsBase = ManipulatorParamsBase;
var ManipulatorParamsPositionBased = (function (_super) {
    tslib_1.__extends(ManipulatorParamsPositionBased, _super);
    function ManipulatorParamsPositionBased(subDocPos) {
        var _this = _super.call(this, true, true) || this;
        _this.subDocPos = subDocPos;
        return _this;
    }
    ManipulatorParamsPositionBased.prototype.correctParams = function () {
        var documentEndPosition = this.subDocPos.subDocument.getDocumentEndPosition();
        this.subDocPos.position = math_1.MathUtils.restrictValue(this.subDocPos.position, 0, documentEndPosition - 1);
    };
    ManipulatorParamsPositionBased.prototype.checkParams = function () {
        var documentEndPosition = this.subDocPos.subDocument.getDocumentEndPosition();
        return this.innerCheck(this.subDocPos.position >= 0 && this.subDocPos.position < documentEndPosition, errors_1.Errors.InternalException);
    };
    return ManipulatorParamsPositionBased;
}(ManipulatorParamsBase));
exports.ManipulatorParamsPositionBased = ManipulatorParamsPositionBased;
var ManipulatorParamsCharacterPropertiesBased = (function (_super) {
    tslib_1.__extends(ManipulatorParamsCharacterPropertiesBased, _super);
    function ManipulatorParamsCharacterPropertiesBased(subDocPos, charPropsBundle) {
        var _this = _super.call(this, subDocPos) || this;
        _this.charPropsBundle = charPropsBundle;
        return _this;
    }
    ManipulatorParamsCharacterPropertiesBased.prototype.checkParams = function () {
        return _super.prototype.checkParams.call(this) &&
            this.innerCheck(!!this.charPropsBundle.props, errors_1.Errors.InternalException) &&
            this.innerCheck(!!this.charPropsBundle.style, errors_1.Errors.InternalException);
    };
    return ManipulatorParamsCharacterPropertiesBased;
}(ManipulatorParamsPositionBased));
exports.ManipulatorParamsCharacterPropertiesBased = ManipulatorParamsCharacterPropertiesBased;
